import { render, staticRenderFns } from "./CGSZ.vue?vue&type=template&id=2c33ec7a&scoped=true"
import script from "./CGSZ.vue?vue&type=script&lang=js"
export * from "./CGSZ.vue?vue&type=script&lang=js"
import style0 from "./CGSZ.vue?vue&type=style&index=0&id=2c33ec7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33ec7a",
  null
  
)

export default component.exports